import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityIconLinkBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { useTechdocsReaderIconLinkPropsWithProvider } from './useTechdocsReaderIconLinkPropsWithProvider';

// Sobrescreve o icon link "read-docs" do plugin techdocs: mesmo "name", e o
// módulo precisa declarar pluginId: 'techdocs' (o dono original da
// extensão) - sem isso o Backstage ignora a extensão silenciosamente e
// mantém a padrão (mesmo padrão já usado em App.tsx para sobrescrever a
// SignInPage do plugin 'app').
const readDocsIconLink = EntityIconLinkBlueprint.make({
  name: 'read-docs',
  params: {
    useProps: useTechdocsReaderIconLinkPropsWithProvider,
  },
});

export const techdocsProviderLinkModule = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [readDocsIconLink],
});
